import { Link } from "react-router-dom";

import withLayoutSimple from "../../components/withLayoutSimple/withLayoutSimple";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageCousinD.module.scss";

function PageCousinD() {
  const getImgSet = useImgSet();

  const item01 = getImgSet("item__01__p33", "png", [s.item, s.item__01]);
  const pointer = getImgSet("pointer__cousin", "png", s.pointer);

  const back = getImgSet("back__p22", "png");
  const imgA = getImgSet("bear__04__alt", "png", s.img__a);
  const imgB = getImgSet("bear__05__alt", "png", s.img__b);
  const description = getImgSet("description__p33", "png", s.description);
  const noticeA = getImgSet("notice__a__p33", "png");
  const noticeB = getImgSet("notice__b__p33", "png");

  return (
    <div className={s.root}>
      {pointer}
      <div className={s.aside_left}>
        <Link to="/cousin/e" className={s.notice__a}>
          {noticeA}
        </Link>
        <div className={s.bears}>
          {imgA}
          {imgB}
        </div>
        <Link to="/cousin/f" className={s.notice__b}>
          {noticeB}
        </Link>
      </div>
      <div className={s.inner}>{item01}</div>
      <div className={s.aside_right}>
        <Link to="/cousin/" className={s.back}>
          {back}
        </Link>
        {description}
      </div>
    </div>
  );
}

export default withLayoutSimple(PageCousinD, false, true, true, true);
